import { APIClient } from '@/services'
import { useReadSearchParams } from '@/utils/hooks/useReadSearchParams'

export function useSearchedIndustry() {
  const industryParam = useReadSearchParams().industry

  const industry = APIClient.Organisations.useIndustry(industryParam)

  return industry
}
